/*
 * Copyright (c) 2024.
 * The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import UiFilterLabel from "./Filter/UiFilterLabel";
import UiFilterButton from "./Filter/UiFilterButton";
import clsx from "clsx";
import {useDebouncedCallback} from "use-debounce";

export interface UiTabSwitcherItem {
    id: number | string;
    name: string;
}

interface UiTabSwitcherProps {
    selected: string | number;
    label?: string;
    className?: string;
    classNameButton?: string;
    onClick: (tab: string | number) => void;
    items: UiTabSwitcherItem[];
    disabled?: boolean;
}

const UiTabSwitcher = (props: UiTabSwitcherProps) => {
    const debouncedChangeHandler = useDebouncedCallback(data => props.onClick(data), 300);

    const onClickHandler = (id: number | string) => {
        debouncedChangeHandler(id);
    };

    return (
        <div className={clsx("UiTabSwitcher flex flex-col w-auto", props.className && props.className)}>
            {props.label && <UiFilterLabel label={props.label} />}
            <div className={"flex flex-row items-center shadow-sm shadow-black/10 rounded peer self-baseline"}>
                {props.items &&
                    props.items.map((item, index) => {
                        const isSelected = item.id === props.selected;
                        return (
                            <UiFilterButton
                                key={index}
                                active={isSelected}
                                className={clsx("last-of-type:border-r border-r-0", props.classNameButton && props.classNameButton)}
                                disabled={props.disabled || isSelected}
                                title={item.name}
                                onClick={() => onClickHandler(item.id)}
                            />
                        );
                    })}
            </div>
        </div>
    );
};

export default UiTabSwitcher;
